/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WPTransactionResponse = {
    /**
     * Transaction ID
     */
    id: string;
    /**
     * Action type
     */
    action: WPTransactionResponse.action;
    /**
     * Human-readable action description
     */
    actionDescription: string;
    /**
     * Whale points amount (positive for earn, negative for spend)
     */
    whalePoints: number;
    /**
     * Transaction description
     */
    description: string;
    /**
     * Transaction timestamp
     */
    timestamp: string;
};
export namespace WPTransactionResponse {
    /**
     * Action type
     */
    export enum action {
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
        '_5' = 5,
    }
}

